module.exports = __webpack_public_path__ + "media/AppsMirror.052ef62a1badc10cb07e1acb207ac2d1.svg";